import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGlobe = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M7 9a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M5.75 15a8.015 8.015 0 1 0 9.25 -13" }),
		/* @__PURE__ */ _jsx("path", { d: "M11 17v4" }),
		/* @__PURE__ */ _jsx("path", { d: "M7 21h8" })
	]
});
export { SvgGlobe as ReactComponent };
